// noinspection JSUnresolvedReference

import {randomUniqueId} from "../../../../inputs/random/strings";
import createElement from "../../../../createElement";

// noinspection JSUnusedGlobalSymbols
class CheckboxHeaderComponent {
	init(params) {
		const uniqueIdForInput = randomUniqueId('custom-grid-checkbox-header-');
		this.params = params;
		this.eGui = createElement(`
			<div class="ag-header-select-all" style="width: 100%; display: flex; justify-content: center; margin: 0">
                <input
                	type="checkbox"
					class="ag-input-field-input ag-checkbox-input"
					id="${uniqueIdForInput}"
			   >
                <label
					class="ag-checkbox-label"
					for="${uniqueIdForInput}"
				>
				</label>
            </div>
		`);

		/** @var {HTMLInputElement} */
		this.checkbox = this.eGui.querySelector('input[type="checkbox"]');

		// Add event listener for checkbox changes
		this.checkbox.addEventListener('change', e => this.onCheckboxChanged(e));

		// Retrieve grid instance from window object
		this.gridInstance = window[this.params.gridInstanceGlobalTempId];

		// Register itself in grid instance meta property
		// Initializes state for custom row selection columns
		const gridInstance = this.getGridInstance();
		if (!gridInstance._meta) {
			gridInstance._meta = {};
		}

		if (!gridInstance._meta.customRowSelectionStateHeader) {
			gridInstance._meta.customRowSelectionStateHeader = {}
		}

		// Save itself in grid meta properties so it can be accessed outside here
		gridInstance._meta.customRowSelectionStateHeader[params.pickerName] = this;
	}

	getGui() {
		return this.eGui;
	}

	destroy() {
		// Clean up event listeners when component is destroyed
		if (this.checkbox) {
			this.checkbox.removeEventListener('change', this.onCheckboxChanged.bind(this));
		}
	}

	onCheckboxChanged(event) {
		const checked = event.target.checked;

		if (checked) {
			// Clear selected and set 'all' selection state
			const state = this.getRowSelectionState();
			state.selectionType = 'all';
			state.selected = {};
			state.excluded = {};
		} else {
			// Clear selected and set 'simple' selection state
			const state = this.getRowSelectionState();
			state.selectionType = 'simple';
			state.selected = {};
			state.excluded = {};
		}

		// Rerender grid column
		// Obtain the grid's API to refresh the cell renderers for the specified column
		const gridApi = this.gridInstance.api;

		// Maybe we could optimize this by not refreshing the whole cell from scratch...
		gridApi.refreshCells({columns: [this.params.pickerName], force: true});
	}

	/**
	 * Returns the original grid options that was passed during grid creation
	 * The one containing our own custom wrapper.
	 */
	getGridInstance() {
		return this.gridInstance;
	}

	/**
	 * @return {GridCustomColumnRowSelectionDefs.CustomRowSelectionState}
	 */
	getRowSelectionState() {
		const gridInstance = this.getGridInstance();

		return gridInstance._meta.customRowSelectionState[this.params.pickerName];
	}

	handleRowSelection() {
		const state = this.getRowSelectionState();
		switch (state.selectionType) {
			case "simple":
				if (Object.keys(state.selected).length === 0) {
					// Mark checkbox as empty
					this.checkbox.checked = false;
					this.checkbox.indeterminate = false;
				} else {
					this.checkbox.checked = true;
					this.checkbox.indeterminate = false;
				}
				break;
			case "all":
				// Do nothing, we could clear the checkbox checked status
				// if ALL rows have been excluded, we can't really know
				// that, because sorting filtering messes up with that.
				// If we ever have a raw row count saved even after filtering, then
				// we can do it.
				break;

		}
	}
}

export {CheckboxHeaderComponent};
